enum QueryKeys {
  Totals = "Totals",
  Teams = "Teams",
  WorkCharts = "WorkCharts",
  Quicks = "Quicks",
  GetUser = "GetUser",
  AllRoles = "AllRoles",
  Report = "Report",
  Search = "Search",
  Presets = "Presets",
  Calendar = "Calendar",
  Rows = "Rows",
  Pto = "Pto",
  getHoursSummary = "getHoursSummary",
  Details = "Details",
  Users = "Users",
  TimeZones = "TimeZones",
  GroupsNoTeams = "GroupsNoTeams",
  GroupsWithRoles = "GroupsWithRoles",
  Roles = "Roles",
  RightTypes = "RightTypes",
  SaveChanges = "SaveCahgens",
  Kinds = "Kinds",
  Entries = "Entries",
  Children = "Children",
  Transactions = "Transaction",
  GroupsDetails = "GroupsDetails",
  Delete = "Delete",
  HoursInTheBank = "HoursInTheBank",
  OtherUsers = "OtherUsers",
  WorkChartsAbleToBeParents = "WorkChartsAbleToBeParents",
  DurationKinds = "DurationKinds",
}
export default QueryKeys;
